module.exports = __webpack_public_path__ + "img/Blumenwiese-1024@2x.7a6930c5.jpg";